// extracted by mini-css-extract-plugin
export var container__title = "FeaturedVentilador-module--container__title--be7ac";
export var img = "FeaturedVentilador-module--img--2e863";
export var imgBase = "FeaturedVentilador-module--imgBase--3c8d8";
export var imgHovered = "FeaturedVentilador-module--imgHovered--4a870";
export var imgNotHovered = "FeaturedVentilador-module--imgNotHovered--a53eb";
export var img__container = "FeaturedVentilador-module--img__container--a9226";